import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { PartKey, Reward, UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';

export interface PartSummary {
  itemCount: number;
  gameCount: number;
  slideshowCount: number;
  completedItemCount: number;
  completedGameCount: number;
  completedSlideshowCount: number;
  scoreTotal: number;
  performances: Partial<Record<'0' | '1' | '2' | '3' | '4' | '5', number>>;
  totalDurationInMs: number;
  remainingReward: Reward;

  hasChallenge: boolean;
  completedChallengeCount: number;
  latestChallengeScore: number; // float
  latestChallengeDurationInMs: number;
  hasPractice: boolean;
  completedPracticeCount: number;
  latestPracticeScore: number; // float
  latestPracticeDurationInMs: number;
  averageGameScore: number; // float
}

type Parts = { overall: PartSummary } & Partial<Record<PartKey, PartSummary>>; // overall will be removed

type ForgettingCurve<T> = {
  computedAt: T;
  memoryRetentionValues: number[];
  estimatedRetentionValues: number[];
};

type Challenge = {
  challengeCount: number;
  practiceCount: number;
  completedChallengeCount: number;
  completedPracticeCount: number;
  scoreTotal: number;
  totalDurationInMs: number;
  remainingReward: Reward;
};

type PathSummary<T> = {
  currentStation: number;
  smallJoyBallCount: number;
  mediumJoyBallCount: number;
  largeJoyBallCount: number;
  grandPrize: Reward;
  collectedGrandPrizeAt?: T;
  collectedJoyBallAt?: T;
  collectedStarPointAt?: T;
  unlockedStations: number;
};

export interface AlbumSummaryJson<T = number> {
  readonly gameSetId: string;
  userId: UserId;
  classroomId: Uuid;
  createdAt: T;
  lastModifiedAt: T;
  lastComputedAt: T;
  parts: Parts;
  challenge: Challenge;
  forgettingCurve?: ForgettingCurve<T>;
  path?: PathSummary<T>;
}

export class AlbumSummary
  extends RepositoryElement
  implements AlbumSummaryJson<Date>
{
  readonly gameSetId!: string; // identifier,
  userId!: UserId;
  classroomId!: Uuid;
  createdAt!: Date;
  lastModifiedAt!: Date;
  lastComputedAt!: Date;
  parts!: Parts;
  challenge!: Challenge;
  forgettingCurve?: ForgettingCurve<Date>;
  path?: PathSummary<Date>;

  constructor(albumSummary: AlbumSummaryJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(albumSummary));

    // FIXME: use the sum until both frontend and backend support item count field
    Object.values(this.parts).forEach((part) => {
      if (part.completedItemCount === undefined) {
        part.completedItemCount =
          part.completedGameCount + part.completedSlideshowCount;
      }
    });
  }

  id(): string {
    return `${this.gameSetId}_${this.userId}`;
  }

  toJSON(): AlbumSummaryJson {
    return deepTransformDate(this) as unknown as AlbumSummaryJson;
  }

  // get completedCount(): number {
  //   return this.parts.overall.completedItemCount;
  // }

  // incrementPart(
  //   partId: keyof Parts,
  //   increment:
  //     | Pick<PartSummary, 'completedGameCount'>
  //     | Pick<PartSummary, 'completedSlideshowCount'>
  //     | Pick<
  //         PartSummary,
  //         'latestChallengeScore' | 'latestChallengeDurationInMs'
  //       >
  //     | Pick<PartSummary, 'latestPracticeScore' | 'latestPracticeDurationInMs'>,
  // ): void {
  //   const part = this.parts[partId];
  //   if (part) {
  //     if ('completedGameCount' in increment) {
  //       part.completedGameCount += increment.completedGameCount;
  //     } else if ('completedSlideshowCount' in increment) {
  //       part.completedSlideshowCount += increment.completedSlideshowCount;
  //     } else if ('latestChallengeScore' in increment) {
  //       part.completedChallengeCount++;
  //       part.latestChallengeScore += increment.latestChallengeScore;
  //       part.latestChallengeDurationInMs =
  //         increment.latestChallengeDurationInMs;
  //     } else if ('latestPracticeScore' in increment) {
  //       part.completedPracticeCount++;
  //       part.latestPracticeScore += increment.latestPracticeScore;
  //       part.latestPracticeDurationInMs = increment.latestPracticeDurationInMs;
  //     }
  //   }
  // }
}
